import Vue from 'vue'
import Router from 'vue-router'
import Constels from './views/Constels.vue'
import ConstelDetails from './views/ConstelDetails.vue';
import SearchConstel from './views/SearchConstel.vue';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/constels',
      name: 'constels',
      component: Constels,
      meta: {
        name: '观天识星'
      }
    },
    {
      path: '/home',
      name: 'home',
      component: Constels,
      meta: {
        name: '观天识星'
      }
    },
    {
      path: '/searchConstel',
      name: 'searchConstel',
      component: SearchConstel,
      meta: {
        name: '星座搜索'
      }
    },
    {
      path: '/constelDetails',
      name: 'constelDetails',
      component: ConstelDetails,
      meta: {
        name: '星座详情'
      }
    },
  ]
});

router.beforeEach((to, from, next)=>{
  if(to.meta.name){
    document.title = to.meta.name
  }
  next();
});

export default router;
